import React from "react"
import VelgFraListen from "./VelgFraListen"
import { SelectedKontoParam } from "./SelectedKonto"
import KontoInfoView from "./KontoInfoView"
import Card from "../shared/Card"

const SelectedKontoContent = ({ konto }: SelectedKontoParam): React.ReactElement => {
  if (konto === null) {
    return <VelgFraListen />
  }

  return <KontoInfoView konto={konto} />
}

export default function SelectedKontoColumn({ konto }: SelectedKontoParam): React.ReactElement {
  return (
    <Card>
      <SelectedKontoContent konto={konto} />
    </Card>
  )
}
